import { ApplicationState } from '../../../../store/types';
import { ColumnSort, TableFilters } from '../../../shared/table/types';
import { getAttestationsRoot } from '../../store/selectors';
import { AttestationConfirmationModal, AttestationManagerTableRow, AttestationForm, AttestationFormDB, AttestationManager, AttestationManagerTab, AttestationPage, FormBuilderTab, NewAttestationInstances } from './types';

export const getAttestationPage = (state: ApplicationState): AttestationPage => getAttestationsRoot(state).attestationPage;

export const getFormBuilderWizardOpen = (state: ApplicationState): boolean => getAttestationsRoot(state).formBuilderWizardOpen;

export const getSelectedFormTab = (state: ApplicationState): FormBuilderTab => getAttestationsRoot(state).selectedFormTab;

export const getSelectedAttestationForm = (state: ApplicationState): AttestationForm | null => getAttestationsRoot(state).selectedAttestationForm;

export const getAttestationConfigModalOpen = (state: ApplicationState): number | null => getAttestationsRoot(state).attestationQuestionConfigModalOpen;

export const getAttestationConfirmationModalOpen = (state: ApplicationState): AttestationConfirmationModal | null => getAttestationsRoot(state).attestationConfirmationModal;

export const getIsSaving = (state: ApplicationState): boolean => getAttestationsRoot(state).isSaving;

export const getIsLoading = (state: ApplicationState): boolean => getAttestationsRoot(state).isLoading;

export const getAllAttestationForms = (state: ApplicationState): AttestationFormDB[] => getAttestationsRoot(state).attestationForms;

export const getAttestationFormUpdated = (state: ApplicationState): boolean => getAttestationsRoot(state).attestationFormUpdated;

export const getAttestationInstancesCompleted = (state: ApplicationState): boolean => getAttestationsRoot(state).viewCompletedAttestations;

export const getNewAttestationModalOpen = (state: ApplicationState): boolean => getAttestationsRoot(state).newAttestationModalOpen;

export const getNewAttestations = (state: ApplicationState): NewAttestationInstances | null => getAttestationsRoot(state).newAttestations;

export const getManagerWizardOpen = (state: ApplicationState): boolean => getAttestationsRoot(state).attestationManagerWizardOpen;

export const getSelectedManagerTab = (state: ApplicationState): AttestationManagerTab => getAttestationsRoot(state).selectedManagerTab;

export const getSelectedAttestationInstance = (state: ApplicationState): AttestationManager | null => getAttestationsRoot(state).selectedAttestationInstance;

export const getAllAttestationInstances = (state: ApplicationState): AttestationManager[] => getAttestationsRoot(state).attestations;

export const getAttestationInstanceUpdated = (state: ApplicationState): boolean => getAttestationsRoot(state).attestationInstanceUpdated;

export const getConfirmDeleteAttestationForm = (state: ApplicationState): AttestationForm | null => getAttestationsRoot(state).confirmDeleteAttestationForm;

export const getConfirmDeleteAttestation = (state: ApplicationState): AttestationManagerTableRow | null => getAttestationsRoot(state).confirmDeleteAttestation;

export const getIsDeleting = (state: ApplicationState): boolean => getAttestationsRoot(state).isDeleting;

// Table Filters and Pagination
export const getAttestationInstancesPageNumber = (state: ApplicationState): number => getAttestationsRoot(state).attestationInstancesPage;
export const getTotalAttestationInstances = (state: ApplicationState): number => getAttestationsRoot(state).totalAttestationInstances;
export const getAttestationInstancesFilters = (state: ApplicationState): TableFilters => getAttestationsRoot(state).attestationInstancesFilters;
export const getAttestationInstancesColumnSort = (state: ApplicationState): ColumnSort | undefined => getAttestationsRoot(state).attestationInstancesSort;
export const getAttestationInstancesPageSize = (state: ApplicationState): number => getAttestationsRoot(state).attestationInstancesPageSize;
